import { render, staticRenderFns } from "./SalaryListInside.vue?vue&type=template&id=f0b472c8&scoped=true&"
import script from "./SalaryListInside.vue?vue&type=script&lang=js&"
export * from "./SalaryListInside.vue?vue&type=script&lang=js&"
import style0 from "./SalaryListInside.vue?vue&type=style&index=0&id=f0b472c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b472c8",
  null
  
)

export default component.exports